import axios from 'axios'
import { clone } from '@/util/libUtil.js'


const state = () => ({
    isOpenDialog: false,
    isEditableForm: false,
    formType: '',
    editingId: '',
    Name: '',
    Operator: '',
    Type: '',
    Upfront: null,
    // FamiliaObjetivo: null,
    SelectedSegment: '',
    IsActive: false,
    upfront_history: [],
    procedures: [],
    paths: {
        procedurePath: '/api/servicios/gestion/',
    }
})

const initialState = {...state()}

const mutations = {
    resetStore: (state) => {
        let copy = [...state.procedures]
        initialState.procedures = copy
        Object.assign(state, initialState)
    },
    upfront_history: (state, val) => {
        state.upfront_history = clone(val);
    },
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    isEditableForm: (state, val) => {
        state.isEditableForm = val;
    },
    formType: (state, val) => {
        state.formType = val;
    },
    editingId: (state, val) => {
        state.editingId = val;
    },
    Name: (state, val) => {
        state.Name = val
    },
    Operator: (state, val) => {
        state.Operator = val
    },
    Upfront: (state, val) => {
        state.Upfront = val
    },
    // FamiliaObjetivo: (state, val) => {
    //     state.FamiliaObjetivo = val
    // },
    Type: (state, val) => {
        state.Type = val
    },
    IsActive: (state, val) => {
        state.IsActive = val
    },
    procedures: (state, val) => {
        state.procedures = clone(val)
    },
}

const actions = {
    async getProcedures({ dispatch, getters, state, commit }) {
        try {
            // commit('ManagementBase/loadingItems', true, {root: true})
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.procedurePath))
            commit('procedures', resp.data)
            // commit('ManagementBase/loadingItems', false, {root: true})
            // dispatch('util/showStatusSnackBar', {
            //     statusType: 'success',
            //     message: 'Gestiones Cargadas Correctamente'
            // }, {root: true})
        }
        catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido de Gestiones'
            }, { root: true })
        }
    },
    async delete({ state, dispatch, getters }, item) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.procedurePath) + item.id)
            dispatch('getProcedures')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    async addProcedure({ state, getters, dispatch }) {
        // state.FamiliaObjetivo = state.FamiliaObjetivo ? state.FamiliaObjetivo.map(({ nombre }) => nombre) : null;

        let procedure = {
            'name': state.Name,
            'operator': state.Operator,
            'tipo_gestion': state.Type,
            'is_active': state.IsActive,
        }

        try {
            await axios.post(getters.getEndpointFromPath(state.paths.procedurePath), procedure)
            dispatch('getProcedures')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Gestión Añadida Correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al Añadir Gestión',
            }, { root: true })
        }
    },
    async editProcedure({ state, getters, dispatch }) {
        // state.FamiliaObjetivo = state.FamiliaObjetivo.map(({ nombre }) => nombre)

        let procedure = {
            'name': state.Name,
            'operator': state.Operator,
            'tipo_gestion': state.Type,
            'is_active': state.IsActive,
        }

        try {
            await axios.put(getters.getEndpointFromPath(state.paths.procedurePath) + state.editingId + '/', procedure)
            dispatch('getProcedures')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Gestión Actualizada Correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al Actualizar la Gestión',
            }, { root: true })
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}